import Chart from 'chart.js/auto';

// --- Constants ---
export const WEBSITE_NAME = 'trackcopr.com';

// --- Watermark Plugin (for Chart.js) ---
export const watermarkPlugin = {
    id: 'watermark',
    afterDraw: (chart) => {
        const ctx = chart.ctx;
        const chartArea = chart.chartArea;
        if (!chartArea) {
            return; // Exit if chartArea isn't ready
        }

        ctx.save();

        // Adjusted settings for a less intrusive watermark
        const fontSize = Math.min(chart.width, chart.height) * 0.1; // Dynamic font size
        ctx.font = `bold ${fontSize}px Arial`;
        ctx.fillStyle = 'rgba(255, 0, 0, 0.3)'; // Semi-transparent red
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.globalAlpha = 0.5; // Overall transparency

        // Center within the chartArea
        const centerX = (chartArea.left + chartArea.right) / 2;
        const centerY = (chartArea.top + chartArea.bottom) / 2;

        // Rotate the text
        ctx.translate(centerX, centerY);
        ctx.rotate(-Math.PI / 6); // Rotate -30 degrees
        ctx.fillText(WEBSITE_NAME, 0, 0); // Draw rotated text

        ctx.restore();
    }
};

// --- Download Handler (for Chart.js) ---
export const handleChartJsDownload = (chartRef, chartName, displayDrawName) => {
    if (chartRef.current) {
        try {
            // Set background color for the downloaded image
            const canvas = chartRef.current.canvas;
            const ctx = canvas.getContext('2d');
            ctx.save();
            ctx.globalCompositeOperation = 'destination-over'; // Draw behind existing content
            ctx.fillStyle = 'white'; // Set background color
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            ctx.restore();

            // Get base64 image AFTER setting background
            const base64Image = chartRef.current.toBase64Image('image/png');

            const link = document.createElement('a');
            link.href = base64Image;
            const filename = `${chartName.toLowerCase().replace(/ /g, '-')}-chart-${displayDrawName.toLowerCase().replace(/ /g, '-')}.png`;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

        } catch (error) {
            console.error("Error generating or downloading Chart.js image:", error);
            alert("Sorry, couldn't download the chart image.");
        }
    } else {
        console.error("Chart.js reference not found for downloading.");
        alert("Could not get chart data to download.");
    }
};

// --- Global Registration (Optional but recommended if used everywhere) ---
// Call this once in your main App component or index.js if you want the watermark on ALL Chart.js charts by default
export const registerChartJsWatermarkGlobally = () => {
    Chart.register(watermarkPlugin);
    // ("Chart.js watermark plugin registered globally.");
};